import * as React from "react";
import { NavLink } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import { Trad } from "../../../components";
import { GetUserImg } from "../../helpers/Common";

export const GetUsersListColumns = () => [
    {
        name: "ID_Utente",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Nome",
        label: Trad.Trad("Nome"),
        options: {
            filter: false
        }
    },
    {
        name: "Cognome",
        label: Trad.Trad("Cognome"),
        options: {
            filter: false
        }
    },
    {
        name: "Login",
        label: Trad.Trad("Login"),
        options: {
            filter: false
        }
    },
    {
        name: "Email",
        label: Trad.Trad("Email"),
        options: {
            filter: false
        }
    },
    {
        name: "Immagine",
        label: Trad.Trad("Immagine"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string) => <Avatar variant="rounded" src={GetUserImg(val)} />
        }
    },
    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => (
                <NavLink to={`/Utente/${tableMeta.rowData[0]}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </NavLink>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/UsersList/UsersListColumns.tsx